import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="m17.2 2.47 10.09 9.5A2 2 0 0 1 28 13.5V28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V13.5a2 2 0 0 1 .71-1.53l10.09-9.5a2 2 0 0 1 2.4 0zm-4.043 8.716A4 4 0 0 1 16 10a4 4 0 0 1 3.96 4.04v.817a5.6 5.6 0 0 1-1.714 3.88l1.183.229c2.714.64 4.571 2.011 4.571 3.605v2.286c0 .631-.512 1.143-1.143 1.143H9.143A1.143 1.143 0 0 1 8 24.857v-2.286c0-1.594 1.834-2.965 4.571-3.605l1.143-.252A5.531 5.531 0 0 1 12 14.857v-.817a4 4 0 0 1 1.157-2.854z" clip-rule="evenodd" stroke="none"></path>';
export var MyHomeSVG = function MyHomeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MyHomeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MyHomeSVG);